export var assign = require("lodash/assign");
export var capitalize = require("lodash/capitalize");
export var filter = require("lodash/filter");
export var find = require("lodash/find");
export var flow = require("lodash/flow");
export var kebabCase = require("lodash/kebabCase");
export var map = require("lodash/map");
export var pickBy = require("lodash/pickBy");
export var round = require("lodash/round");
export var truncate = require("lodash/truncate");
export var upperFirst = require("lodash/upperFirst");
var lodash = {
    assign: assign,
    capitalize: capitalize,
    filter: filter,
    find: find,
    flow: flow,
    kebabCase: kebabCase,
    map: map,
    pickBy: pickBy,
    round: round,
    truncate: truncate,
    upperFirst: upperFirst,
};
export default lodash;



//////////////////
// WEBPACK FOOTER
// ./app/shared/utils/lodash.ts
// module id = cRoh
// module chunks = 2